<template>
  <div v-if="true">
            <section >
                <div class="row mb-4">
                    <div class="col-sm-10"></div>
                    <div class="col-sm-2">
                        <button @click="create" v-if="canEditEntity && !hide_create" style="text-align:center;width:100%" class="btn btn-sm btn-success align-items-center">
                            <span class="d-inline-block me-2 .text-primary-dark">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            </span>
                            <span>{{$t('attachment')}}</span>
                            <!-- &nbsp;<span v-if="business && business.status != 'active'" class="badge bg-secondary"> {{$t('pro')}}</span> -->
                        </button>
                    </div>
                    
                </div>
                
                    
                    <div class="row g-3">
                        <p v-if="!attachments.length" class="text-center py-4 text-muted">{{$t('no_attachment_found')}}</p>
                        <div 
                          class="col-12 col-sm-6 col-md-4 col-lg-3" 
                          v-for="(attachment, index) in attachments" 
                          :key="index"
                        >
                          <div class="attachment-card card h-100 border shadow-sm">
                            <div class="attachment-preview-wrapper bg-light d-flex align-items-center justify-content-center" style="height: 200px; overflow: hidden;">
                              <template v-if="attachment.filetype && attachment.filetype.includes('image')">
                                <img v-if="attachment.temporary_url" :src="attachment.temporary_url" class="img-fluid" style="object-fit: contain; width: 100%; height: 100%; cursor: pointer;" @click="previewAttachment(attachment)">
                                <AppIcon v-else name="bi-file-earmark-image" class="bi bi-file-earmark-image text-primary" style="font-size: 4rem;" />
                              </template>
                              <template v-else-if="attachment.filetype && attachment.filetype.includes('pdf')">
                                <object v-if="attachment.temporary_url" :data="attachment.temporary_url + '#view=Fit'"
                                        :type="attachment.filetype || 'application/pdf'" 
                                        style="width: 100%; height: 100%; pointer-events: none; object-fit: contain;">
                                    <AppIcon name="bi-file-earmark-pdf" class="bi bi-file-earmark-pdf text-danger" style="font-size: 4rem;" />
                                </object>
                              </template>
                              <template v-else>
                                <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text text-primary" style="font-size: 4rem;" />
                              </template>
                            </div>
                            <div class="card-body p-2 d-flex justify-content-between align-items-center">
                              <span class="text-truncate small fw-bold" style="max-width: 150px;">{{ attachment.filename }}</span>
                              <div class="d-flex gap-1">
                                <button class="btn btn-sm btn-outline-primary p-1 lh-1" @click="previewAttachment(attachment)" :title="$t('preview')">
                                  <AppIcon name="bi-eye" class="bi bi-eye" />
                                </button>
                                <button v-if="canEditEntity" class="btn btn-sm btn-outline-danger p-1 lh-1" @click="deleteAttachment(attachment.id)" :title="$t('delete')">
                                  <AppIcon name="bi-trash" class="bi bi-trash" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                   
            </section>


        <!-- create Modal -->
        <div class="modal fade" id="create-modal-attachment" tabindex="-1" aria-labelledby="create-modal-attachment" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('create_attachment')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">

                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('file')}}</label>
                        <input type="file" ref="input1" @change="previewImage" accept=".jpg, .jpeg, .png, .doc, .docx, .pdf" >    
                    </div>

                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                        <input v-model="attachment.filename"  type="string" class="form-control" id="exampleFormControlInput1" placeholder="File name">
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading" @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- create modal -->

  </div>
</template>

<script>

import helper from '../helper'


export default {
  name: 'Attachment',
  components : {
   },
    props : [
        'entity_type',
        'entity_id',
        'hide_create'
    ],
  data(){
    return {
        loading : false,
        search :'',
        attachments : [],
        range: [],
        attachment : {
            filename : '',
        },
        createModal : null,
        file : null,
        showPreviewModal : null
    }
  }, 
  mounted(){
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('create-modal-attachment'))

    this.getattachments()

  },
  methods : {
    create(){
        if(!this.canEditEntity) return
        this.clearForm()
        this.createModal.show()
    },
    async getattachments(){
        try{
            this.loading = true
            let url = `${process.env.VUE_APP_API}/attachments?entity_id=${this.entity_id}&is=true&entity_type=${this.entity_type}`
            
            this.attachments = []
            
            const response = await helper.customGet(url)
            this.loading = false
            this.attachments = await Promise.all(response.data.data.map(async attachment => {
              try {
                const urlResponse = await helper.customGet(`${process.env.VUE_APP_API}/attachments/${attachment.id}/temporary-url?response=json`, { silent: true })
                return { ...attachment, temporary_url: urlResponse.data.url }
              } catch (error) {
                return attachment
              }
            }))
            
        }catch(error){
            this.loading = false
        }

    },
    previewImage(event) {
        this.file = event.target.files[0]
        const maxAllowedSize = 5 * 1024 * 1024; //5MB
        if(this.file.size > maxAllowedSize) return alert('File Too large please upload file less than 5mb')
        this.attachment.filename = this.file.name
    },
    onUpload(file){
        // if(this.business && this.business.status != 'active') return;
        return helper.customUploadFile(file,`businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,{entity_type : this.entity_type, entity_id : this.entity_id})
    },
    clearForm(){
        this.attachment = {
            filename : ''
        }
        this.file = null
    },
    async save(){
        if(!this.canEditEntity) return
        try{
            this.loading = true
            if(!this.file) return alert('FILE IS MISSING')
            const url = await this.onUpload(this.file)
            this.attachment.filepath = url
            this.attachment.filetype = this.file.type
            this.attachment.filesize = this.file.size
            this.attachment.entity_type = this.entity_type
            this.attachment.entity_id = this.entity_id
            // await helper.customPost(`${process.env.VUE_APP_API}/attachments`,this.attachment,{showToast:true})
            this.loading = false
            this.getattachments()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }
    },
    async previewAttachment(attachment) {
      let url = attachment.temporary_url;
      if (!url) {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/attachments/${attachment.id}/temporary-url?response=json`)
        url = response.data.url
        this.$set(attachment, 'temporary_url', url)
      }
      if (attachment.filetype && attachment.filetype.includes('pdf') && !url.includes('#')) {
          url += '#view=Fit';
      }
      window.open(url, '_blank');
    },
    async deleteAttachment(id) {
      if(!this.canEditEntity) return
      const result = await this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      })
      if (result.isConfirmed) {
        await helper.customDelete(`${process.env.VUE_APP_API}/attachments/${id}`)
        this.attachments = helper.withoutDeletedRecords(this.attachments, id)
      }
    }
  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    canEditEntity(){
      if(this.entity_type === 'project') return helper.checkAccess('edit_projects') > 0
      if(this.entity_type === 'task') return helper.checkAccess('edit_tasks') > 0
      return true
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    .attachment-container {
      position: relative;
      overflow: hidden;
    }

    .attachment-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .attachment-container:hover .attachment-overlay {
      opacity: 1;
    }
</style>
